/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespCollectionsComponents_viewer$ref = any;
export type SbRespCollectionsModules_viewer$ref = any;
export type SbRespCollectionsModules_viewer = {
    readonly isCollectionsModuleEnabled: boolean | null;
    readonly " $fragmentRefs": SbRespCollectionsComponents_viewer$ref;
    readonly " $refType": SbRespCollectionsModules_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespCollectionsModules_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isCollectionsModuleEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "BROWSE_COLLECTIONS_MODULES"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"BROWSE_COLLECTIONS_MODULES\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespCollectionsComponents_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'a39f65d84db81d7c0cb5a244ad7bce68';
export default node;
